import React, { useEffect, useLayoutEffect, useState } from "react";
import SnpComponent from "../../global/SnpComponent";
import CustomDataGrid from "../../global/CustomDataGrid";
import { BACKEND_BASE_URL, BillSearchMode, formatDateInSnp, HotelRoomCateogory, printDebugLog, SHOWALLBILLS, SUCCESS } from "../../constants/Constants";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, FormControlLabel, Grid, Paper, Radio, RadioGroup, TextField } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { BOOKINGRIGHTS } from "../../constants/Permissions";
export default function ShowBills() {

    const INITIAL_SNP_COMPONENT = {
        showDialog: false,
        outSideClickDismiss: true,
        title: "",
        subTitle: "",
        negativeAction: "",
        positiveAction: "",
        positiveReq: false,
        iconReq: "",
        snackBarOpen: false,
        snackBarMsg: "",
        cancelExtra: false,
        negativeReq: false,
        handleSnpSubmit: null,
        handleSnpCancel: null,
    };
    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
    const handleSnpDialogClose = () => {
        setSnpComponent(INITIAL_SNP_COMPONENT);
    };

    const handleSnackClose = () => {
        setSnpComponent({
            ...snpComponent,
            snackBarOpen: false,
            snackBarMsg: "",
        });
    };




    const navigate = useNavigate();
    const { activeShopHash, authUser, isRoleAllowed, isInvoiceAllowed } = useAuth();
    const [listBills, setShowBills] = useState([]);

    const [filterSelection, setFilterSelection] = useState(HotelRoomCateogory.HOTEL_BOTH);
    const [searchFilter, setSearchFilter] = useState(BillSearchMode.NA);
    const [selectedDate, setSelectedDate] = useState("");
    const [query, setQuery] = useState("");
    const [snpLoader, setSnpLoader] = useState(false);


    const handleBookRoom = (data) => {
        //console.log("handleBookRoom",data ,encodedId);
        if (data.banquetBooking ?? false) {
            navigate("/createBanquetBill", { state: { id: data.id, via_bill: 1 } });
        } else {
            navigate("/createBill", { state: { id: data.id, via_bill: 1 } });
        }

    };


    const getAllBillDetails = async () => {
        try {
            setSnpLoader(true);
            const url = `${BACKEND_BASE_URL}${SHOWALLBILLS}`;
            const data = {
                payLoad: {
                    shopHash: activeShopHash.id,
                    apiToken: authUser.apiToken,
                    type: filterSelection,
                    searchMode: searchFilter,
                    query: query,
                    selectedDate: formatDateInSnp(selectedDate),
                }
            };
            const response = await axios.post(url, data);
            if (response.data.status === SUCCESS) {
                setShowBills(response.data.payLoad.data);
            }
            setSnpLoader(false);
        } catch (err) {
            console.error("getAllBillDetails", err);
            setSnpLoader(false);
            setSnpComponent({
                ...snpComponent,
                isLoader: false,
                negativeReq: true,
                negativeAction: "Home",
                positiveReq: false,
                showDialog: true,
                outSideClickDismiss: false,
                cancelExtra: true,
                subTitle: "No Bill is Created! Please create",
                handleSnpCancel: () => navigate("/home"),
            });
        }
    };


    useLayoutEffect(() => {
        //console.log('useLayoutEffect : ', CART_INITIAL_STATE, storeActiveShopHash);
        getAllBillDetails();
    }, []);

    useEffect(() => {
        printDebugLog("CreateRoom filterSelection", filterSelection);
        getAllBillDetails();
    }, [filterSelection])

    const columns = [
        {
            field: "view",
            headerName: "View",
            width: 20,
            renderCell: (cellValues) => {
                return (
                    <VisibilityIcon
                        onClick={() => {
                            //console.log("event.row", cellValues.row)
                            if (isRoleAllowed(BOOKINGRIGHTS)) {
                                handleBookRoom(cellValues.row);
                            }
                        }}
                    ></VisibilityIcon>
                );
            },
        },
        {
            field: 'banquetBooking', headerName: 'Type', width: 90, renderCell: (cellValues) => {
                return cellValues?.row?.banquetBooking ?? false ? "Banquet" : "Room"
            }
        },

        { field: 'bookingId', headerName: 'BookingId#', width: 150 },
        { field: 'billAddBy', headerName: 'Sale Person', width: 150 },
        { field: 'billStatus', headerName: 'Status', width: 250 },
        { field: 'finalPrice', headerName: 'F.Price', width: 80 },
        { field: 'cust', headerName: 'Cust.', width: 250 },
        { field: 'checkInDate', headerName: 'On', width: 200 },
        { field: 'checkoutDate', headerName: 'To', width: 200 },
        { field: 'at', headerName: 'Created On', width: 200 },

    ];

    const columnsInvoice = [
        {
            field: "view",
            headerName: "View",
            width: 20,
            renderCell: (cellValues) => {
                return (
                    <VisibilityIcon
                        onClick={() => {
                            //console.log("event.row", cellValues.row)
                            if (isRoleAllowed(BOOKINGRIGHTS)) {
                                handleBookRoom(cellValues.row);
                            }
                        }}
                    ></VisibilityIcon>
                );
            },
        },
        {
            field: 'banquetBooking', headerName: 'Type', width: 90, renderCell: (cellValues) => {
                return cellValues?.row?.banquetBooking ?? false ? "Banquet" : "Room"
            }
        },
        { field: 'invoiceId', headerName: 'InvoiceId#', width: 150 },
        { field: 'bookingId', headerName: 'BookingId#', width: 150 },
        { field: 'billAddBy', headerName: 'Sale Person', width: 150 },
        { field: 'billStatus', headerName: 'Status', width: 250 },
        { field: 'finalPrice', headerName: 'F.Price', width: 80 },
        { field: 'cust', headerName: 'Cust.', width: 250 },
        { field: 'checkInDate', headerName: 'On', width: 200 },
        { field: 'checkoutDate', headerName: 'To', width: 200 },
        { field: 'at', headerName: 'Created On', width: 200 },

    ];

    function getDateMinusDays(dateStr, days = 20) {
        if (!dateStr) return "";

        const date = new Date(dateStr);
        date.setDate(date.getDate() - days);

        // Format back to YYYY-MM-DD
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    }


    const renderSnpContent = () => {
        return (
            <React.Fragment>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Paper
                            elevation={4}
                            sx={{
                                borderRadius: 2,
                                p: 2,
                                backgroundColor: "#f5f5dc",
                            }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <RadioGroup
                                        row
                                        aria-label="type"
                                        name="type"
                                        value={filterSelection}
                                        onChange={(e) => setFilterSelection(Number(e.target.value))}
                                    >
                                        <FormControlLabel
                                            value={HotelRoomCateogory.HOTEL_ROOM}
                                            control={<Radio />}
                                            label="Only Room"
                                        />
                                        <FormControlLabel
                                            value={HotelRoomCateogory.HOTEL_BANKQUET}
                                            control={<Radio />}
                                            label="Only Banquet"
                                        />
                                        <FormControlLabel
                                            value={HotelRoomCateogory.HOTEL_BOTH}
                                            control={<Radio />}
                                            label="Room/Banquet"
                                        />
                                    </RadioGroup>
                                </Grid>
                                <Grid item xs={12}>
                                    <RadioGroup
                                        row
                                        aria-label="searchMode"
                                        name="searchMode"
                                        value={searchFilter}
                                        onChange={(e) => setSearchFilter(Number(e.target.value))}
                                    >
                                        <FormControlLabel
                                            value={BillSearchMode.NA}
                                            control={<Radio />}
                                            label="Search By Date"
                                        />
                                        <FormControlLabel
                                            value={BillSearchMode.BY_MOBILE}
                                            control={<Radio />}
                                            label="Search By Mobile No"
                                        />
                                        <FormControlLabel
                                            value={BillSearchMode.BY_BOOKING_ID}
                                            control={<Radio />}
                                            label="Search By Booking Id"
                                        />
                                        {
                                            isInvoiceAllowed &&
                                            <FormControlLabel
                                                value={BillSearchMode.BY_INVOICE_ID}
                                                control={<Radio />}
                                                label="Search By Invoice Id"
                                            />
                                        }
                                    </RadioGroup>
                                </Grid>
                                <Grid item md={6} sm={6} xs={12} lg={6}>
                                    <TextField
                                        id="date"
                                        label="Select Date"
                                        type="date"
                                        disabled={searchFilter !== BillSearchMode.NA}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        helperText={
                                            selectedDate
                                                ? `It will fetch from ${getDateMinusDays(selectedDate)} to ${selectedDate}`
                                                : ""
                                        }
                                        value={selectedDate}
                                        onChange={(e) => setSelectedDate(e.target.value)}
                                        fullWidth

                                    />
                                </Grid>
                                <Grid item md={6} sm={6} xs={12} lg={6}>
                                    <TextField
                                        required
                                        id="query"
                                        variant="filled"
                                        size="small"
                                        disabled={searchFilter === BillSearchMode.NA}
                                        label={searchFilter === BillSearchMode.BY_MOBILE ?
                                            "Enter Mobile Number" : searchFilter === BillSearchMode.BY_INVOICE_ID ?
                                                "Enter Invoice Id" :
                                                "Enter Booking Id"}
                                        name="query"
                                        value={query}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(e) => setQuery(e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Paper></Grid>

                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary" onPointerDown={() => getAllBillDetails()}>
                            Search
                        </Button>
                    </Grid>
                    <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
                        {/* <div style={{ padding: 10 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ float: "right" }} onClick={() => setComponentIndex(getIndex())}>
                                Start Billing
                            </Button>
                        </div> */}
                        <CustomDataGrid
                            getRowId={row => row.id}
                            rows={listBills}
                            loading={snpLoader}
                            columns={isInvoiceAllowed ? columnsInvoice : columns}
                            title="Show All Bills"
                        />
                    </Grid></Grid>
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            <SnpComponent showDialog={snpComponent.showDialog}
                title={snpComponent.title}
                subTitle={snpComponent.subTitle}
                negativeAction={snpComponent.negativeAction}
                positiveReq={snpComponent.positiveReq}
                positiveAction={snpComponent.positiveAction}
                negativeReq={snpComponent.negativeReq}
                onClose={handleSnpDialogClose}
                iconReq={snpComponent.iconReq}
                content={renderSnpContent()}
                onSnackClose={handleSnackClose}
                cancelExtra={snpComponent.cancelExtra}
                handleSubmit={snpComponent.handleSnpSubmit}
                onCancel={snpComponent.handleSnpCancel}
                outSideClickDismiss={snpComponent.outSideClickDismiss}
            />
        </React.Fragment>
    );
};